import React from 'react';
import { Button, Grid } from 'semantic-ui-react';
import { default as pt } from 'prop-types';
import { KeywordFilter } from '../../../common/components/filter/KeywordFilter';
import { VenueFilter } from '../../../common/components/filter/VenueFilter';
import { TimeFilter } from '../../../common/components/filter/TimeFilter';
import styles from '../../../common/components/buttons/styles/styles.scss';
/**
 * Menu NavBar for filtering events
 */
const EventsFilterMenu = ({
  venues,
  times,
  filterSelections,
  handleFilterSelection,
  handleCMSEventFetch,
}) => {
  const isShowingCMS = window.location.pathname.includes('cms');
  const cmsButtonText = `${isShowingCMS ? 'Hide' : 'Show'} CMS Only Events`;
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column mobile={5} computer={3}>
          <TimeFilter
            times={times}
            handleSelection={handleFilterSelection}
            selectedTime={filterSelections.time}
          />
        </Grid.Column>
        <Grid.Column mobile={5} computer={4}>
          <Button
            content={cmsButtonText}
            className={`${styles['show-cms-events-toggle']}`}
            primary
            size={'small'}
            onClick={handleCMSEventFetch}
          />
        </Grid.Column>
        <Grid.Column mobile={4} computer={3}>
          <VenueFilter
            venues={venues}
            handleSelection={handleFilterSelection}
            selectedVenue={filterSelections.venue}
          />
        </Grid.Column>
        <Grid.Column mobile={6}>
          <KeywordFilter
            filter={(e) =>
              handleFilterSelection(null, {
                type: 'keyword',
                value: e.target.value,
              })
            }
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

EventsFilterMenu.propTypes = {
  /**
   * Current filter selections.
   */
  filterSelections: pt.object.isRequired,
  /**
   * All possible venues
   * @type {[array]}
   */
  venues: pt.array.isRequired,
  /**
   * Filters events based on time
   * @type {[function]}
   */
  handleFilterSelection: pt.func.isRequired,
  times: pt.array,
  eventsType: pt.string,
};

export default EventsFilterMenu;



// WEBPACK FOOTER //
// ./src/routes/Events/components/EventsFilterMenu.js